module.exports = __webpack_public_path__ + "media/שופר.d53bf6f0.mp3";